<template>
  <div>
    <b-row>
      <b-col md="6" lg="6" xl="6">
        <vxe-grid
          auto-resize
          highlight-hover-row
          :toolbar-config="tableToolbar"
          :data="tableData"
          :columns="tableColumns"
          :loading="loading"
          :height="400"
          size="mini"
          resizable
          border
          :seq-config="{
            startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
          }"
        >
          <template v-slot:toolbar_form>
            <slot name="header"></slot>
          </template>
          <template v-slot:pager>
            <slot name="pager"></slot>
          </template>
          <template v-slot:opt="{ row }">
            <div>
              <el-button size="mini" @click="rowSelect(row)">
                {{ $l('INDEX.btn_choice') || '选择' }}
              </el-button>
            </div>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
              </p>
            </div>
          </template>
        </vxe-grid>
      </b-col>
      <b-col md="6" lg="6" xl="6">
        <vxe-grid
          auto-resize
          highlight-hover-row
          :data="selectedTable"
          :toolbar-config="tableToolbar"
          :height="400"
          size="mini"
          :columns="tablecolumn"
          resizable
          border
        >
          <template v-slot:toolbar_form> </template>
          <template v-slot:opt="{ row }">
            <div>
              <el-button size="mini" @click="delRow(row)">
                {{ $l('INDEX.btn_delete') || '删除' }}
              </el-button>
            </div>
          </template>
        </vxe-grid>
      </b-col>
    </b-row>
    <!--按钮-->
    <!-- <div style="display: flex;justify-content: flex-end;" class="mt-5 mr-5">
      <el-button @click="goBack" size="small">{{
        $l('INDEX.btn_go_back') || '返回'
      }}</el-button>
      <el-button @click="save" size="small" type="primary">{{
        $l('INDEX.btn_save') || '保存'
      }}</el-button>
    </div> -->
    <!--选择产品属性字典弹框-->
    <el-dialog
      :title="$l('INDEX.dialogTitle_contentInformation') || '含量信息'"
      :visible.sync="contentVisible"
      :show-close="true"
      width="500px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="90px"
        onsubmit="return false"
        @keyup.enter.native="contentSave"
      >
        <el-row>
          <el-col :span="18">
            <el-form-item :label="$l('INDEX.table_label_content') || '含量'">
              <el-input
                v-model="formData.content"
                size="small"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="10"
                @blur="contentBlur"
                ref="contentInput"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="display: flex;justify-content: flex-end;" class="mr-5">
        <el-button @click="contentClose" size="small">{{
          $l('INDEX.btn_go_back') || '返回'
        }}</el-button>
        <el-button @click="contentSave" size="small" type="primary">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
    tablePage: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      formData: {
        content: '',
      },
      selectedTable: [],
      contentVisible: false,
      row: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },

      tableColumns: [
        {
          title: this.$l('INDEX.table_label_Chinese_Name') || '中文名称',
          field: 'attributeName',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_English_Name') || '英文名称',
          field: 'attributeNameEn',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 80,
          slots: {
            default: 'opt',
          },
        },
      ],

      tablecolumn: [
        {
          title: this.$l('INDEX.table_label_Chinese_Name') || '中文名称',
          field: 'attributeName',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_English_Name') || '英文名称',
          field: 'attributeNameEn',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_content') || '含量',
          field: 'content',
          headerAlign: 'center',
          align: 'center',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 80,
          slots: {
            default: 'opt',
          },
        },
      ],
    }
  },
  methods: {
    //选择左侧列表
    rowSelect(row) {
      this.contentVisible = true
      this.$nextTick(() => {
        this.$refs.contentInput.focus()
      })
      this.row = JSON.parse(JSON.stringify(row))
    },
    //填写含量确认按钮
    contentSave() {
      let confirm = this.contentBlur()
      if (confirm && this.row) {
        this.row.content = this.formData.content + '%'
        if (this.selectedTable.length === 0) {
          this.selectedTable.push(this.row)
        } else {
          let i = 0
          this.selectedTable.forEach((e, index) => {
            if (e.attributeName === this.row.attributeName) {
              this.$set(this.selectedTable, index, this.row)
            } else {
              i++
            }
          })
          if (this.selectedTable.length === i) {
            this.selectedTable.push(this.row)
          }
        }
        this.formData.content = ''
        this.row = {}
        this.contentVisible = false
      }
    },
    // 关闭填写含量弹框
    contentClose() {
      this.contentVisible = false
      this.formData.content = ''
      this.row = {}
    },
    //点击右侧列表删除
    delRow(scope) {
      this.selectedTable.splice(scope.$index, 1)
    },
    //判断 含量 填写是否合法
    contentBlur() {
      if (this.formData.content) {
        let verification = /^(\d|[1-9]\d|100)(\.\d{1,2})?$/
        if (!verification.test(this.formData.content)) {
          this.formData.content = ''
          this.$message.warning(
            this.$l('INDEX.tips_fnitro1k1dp') ||
              '范围在1~100的数字，保留1~2位小数'
          )
          return false
        }
        return true
      }
    },
    // 保存所选含量
    save() {
      if (this.selectedTable.length <= 0) {
        this.$message.warning(
          this.$l('INDEX.tips_pleaseSelectData') || '请选择数据'
        )
        return
      }
      let attributeName = ''
      let attributeNameEn = ''
      this.selectedTable.forEach((item) => {
        attributeName += item.attributeName + '-' + item.content + ';'
        attributeNameEn += item.attributeNameEn + '-' + item.content + ';'
      })
      if (attributeName) {
        attributeName = attributeName.substring(0, attributeName.length - 1)
      }
      if (attributeNameEn) {
        attributeNameEn = attributeNameEn.substring(
          0,
          attributeNameEn.length - 1
        )
      }
      let data = {
        attributeName: attributeName,
        attributeNameEn: attributeNameEn,
      }
      this.$emit('selData', data)
      this.goBack()
    },
    goBack() {
      this.reset()
      this.$emit('goBack')
    },
    reset() {
      this.formData = {
        content: '',
      }
      this.row = {}
      this.selectedTable = []
    },
  },
}
</script>
